import React, { useState, useEffect } from 'react';
import { useTheme, IconButton, Tooltip, Stack, Typography } from '@mui/material';
import Datatable from '../../../../components/DataTable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { checkPermission } from '../../../../redux/features/authSlice';
import { useSelector } from 'react-redux';

const companyType = [
  {
    id: 1,
    name: 'Ship Owner',
  },
  {
    id: 2,
    name: 'Ship Manager',
  },
  {
    id: 3,
    name: 'Operator',
  },
  {
    id: 4,
    name: 'Charterer',
  },
];

const clientType = [
  {
    id: 'cwclient',
    name: 'CW Client',
  },
  {
    id: 'bossclient',
    name: 'BOSS Client',
  },
];

const entityType = [
  {
    id: 'private',
    name: 'Private',
  },

  {
    id: 'public',
    name: 'Public',
  },
  {
    id: 'others',
    name: 'Others',
  },
];

export default function Current({ dataList, viewCompany, isLoading, applyFilter, applySort }) {
  const theme = useTheme();
  const [search, setSearch] = useState(null);

  function getBgColor(type) {
    if (type === 'inprogress') {
      return '#006DFF1A';
    }
    if (type === 'Approved') {
      return '#00A63226';
    }
    if (type === 'Rejected') {
      return '#FEF1ED';
    }
    if (type === 'Pending') {
      return '#006DFF1A';
    }
  }

  function getTextColor(type) {
    if (type === 'inprogress') {
      return '#006DFF';
    }
    if (type === 'Approved') {
      return '#00A632';
    }
    if (type === 'Rejected') {
      return '#B11B1B';
    }
    if (type === 'Pending') {
      return '#006DFF';
    }
  }

  const currentBlockedcolumns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'Company Name',
      accessor: 'companyName',
      width: '20%',
      search: false,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [
          {
            name: 'Sort A -> Z',
            id: 'asc',
          },
          {
            name: 'Sort Z -> A',
            id: 'desc',
          },
        ],
      },
    },
    {
      id: 2,
      header: 'Company Type',
      accessor: 'companyType',
      capitalize: true,
      width: '12%',
      search: false,
      filter: {
        search: false,
        filterType: 'checkbox',
        typeFilter: true,
        filterList:
          companyType?.map((item) => {
            return {
              label: item?.name,
              id: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 3,
      header: 'Client Type',
      accessor: 'clientType',
      capitalize: true,
      width: '12%',
      search: false,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList:
          clientType?.map((item) => {
            return {
              name: item?.name,
              id: item?.id,
            };
          }) || [],
      },
      Cell: (item) => (
        <Stack justifyContent="center">
         
              <Typography
                style={{ }}
                className="ff-Roboto fw-regular fs-12"
              >
                {item?.clientType === 'cwclient' ? 'CW Client' : item?.clientType === 'bossclient' ? 'BOSS Client' : '-' }
              </Typography>
            </Stack>
      ),
    },
    {
      id: 4,
      header: ' No of Vessels',
      accessor: 'noOfVessals',
      width: '10%',
    },
    {
      id: 5,
      header: 'Legal Entity Type',
      accessor: 'entityType',
      width: '10%',
      search: false,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList:
          entityType?.map((item) => {
            return {
              name: item?.name,
              id: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 6,
      header: 'State',
      accessor: 'stateName',
      capitalize: true,
      width: '12%',
    },
    {
      id: 7,
      header: 'Country',
      accessor: 'countryName',
      capitalize: true,
      width: '12%',
    },

    {
      id: 8,
      header: 'Action',
      accessor: 'action',
      width: '5%',
      Cell: (value) => (
        <div className="flex !justify-center">
          <Tooltip
            disableInteractive
            title="View"
          >
            <IconButton onClick={() => handleAction('edit', value)}>
              <VisibilityIcon
                style={{
                  color: theme.palette.primary.light,
                  transform: 'scale(0.889)',
                }}
              />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const [customerManagementColumn, setCustomerManagementColumn] = useState(currentBlockedcolumns);

  const handleAction = (type, value) => {
    if (type === 'edit') {
      value[`pageType`] = 'current';
    }
    viewCompany(value);
  };

  return (
    <Datatable
      isLoading={isLoading}
      data={dataList || []}
      onChangeFilter={(filterValues) => {
        const columnUpdate = customerManagementColumn;
        columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
        setCustomerManagementColumn(columnUpdate);
        if (filterValues.accessor === 'companyType') {
          applyFilter({ type: 'company', value: filterValues.filter.selectValue ? companyType.filter((res) => filterValues.filter.selectValue.includes(res.id)).map((res) => res.name.toLowerCase()) : null });
        }
        if (filterValues.accessor === 'entityType') {
          applyFilter({ type: 'entityType', value: filterValues?.filter.selectValue });
        }
        if (filterValues.accessor === 'clientType') {
          applyFilter({ type: 'clientType', value: filterValues?.filter.selectValue });
        }
        if (filterValues.accessor === 'companyName') {
          const columnUpdate = customerManagementColumn;
          columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
          const sValue = filterValues?.filter.selectValue;
          const order = sValue ? sValue : 'desc';
          const field = sValue ? filterValues.accessor : '_id';
          setCustomerManagementColumn(columnUpdate);
          applySort({ order, field });
        }
      }}
      onChangeSort={(sortValues) => {
        const columnUpdate = [...customerManagementColumn];
        columnUpdate[sortValues?.id].sortOrder = sortValues.order;
        columnUpdate[sortValues?.id].sortActive = sortValues.sortActive;
        setCustomerManagementColumn([...columnUpdate]);
        applySort({ order: sortValues.order, field: sortValues.accessor });
      }}
      columns={customerManagementColumn}
    />
  );
}
